import { ColumnDef } from '@tanstack/react-table'
import { AppBox, AppIcon, AppTable, AppTableProps, EmailText, TableActions } from 'components'
import { FC } from 'react'
import { UserWithSubAccounts } from 'sdk'

interface Props extends AppTableProps<UserWithSubAccounts> {
  onManageClick: (user: UserWithSubAccounts) => void
}
export const ManageUsersTable: FC<Props> = ({ onManageClick, ...props }) => {
  const columns: ColumnDef<UserWithSubAccounts>[] = [
    {
      id: 'popover',
      header: () => <></>,
      cell: ({ row }) => {
        return <TableActions row={row} actions={[{ text: 'Manage', onClick: () => onManageClick(row.original) }]} />
      },
    },

    {
      header: 'Account ID',
      cell: ({ row }) => (
        <AppBox display={'flex'} alignItems={'center'} gap={1}>
          {row.original.SubAccounts?.length > 0 && (
            <AppIcon
              color="blue"
              onClick={() => row.toggleExpanded()}
              icon={row.getIsExpanded() ? 'ic:twotone-minus' : 'ic:twotone-plus'}
            />
          )}
          {row.original.AccountId}
        </AppBox>
      ),
    },
    {
      header: 'Name',
      cell: ({ row }) => (row.original.FirstName ?? '') + ' ' + (row.original.LastName ?? ''),
    },
    {
      header: 'Email',
      cell: ({ row }) => <EmailText email={row.original.Email} />,
    },
    {
      header: 'Phone',
      cell: ({ row }) => <EmailText email={row.original.Phone} />,
    },
    {
      header: 'Account Type',
      accessorKey: 'AccountType',
    },
    {
      header: 'User Type',
      accessorKey: 'UserType',
    },
    {
      header: 'Status',
      cell: ({ row }) => (row.original.Active ? 'Enabled' : 'Disabled'),
    },
  ]
  return (
    <>
      <AppTable columns={columns} {...props} />
    </>
  )
}
